import { render, staticRenderFns } from "./ApplicationAdmins.vue?vue&type=template&id=ba97eea2&scoped=true"
import script from "./ApplicationAdmins.vue?vue&type=script&lang=js"
export * from "./ApplicationAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba97eea2",
  null
  
)

export default component.exports